// extracted by mini-css-extract-plugin
export default {"consumptionBetweenTable":"Kudw2xqgbthjDSd7PxXv","header":"Zag0U8yGbf6JQJAjUokS"};